import { isString } from '@utils/guards';

export default function versionSplitterTags<T>(value: T): string | T {
  if (!isString(value)) {
    return value;
  }

  return value
    .split(',')
    .map((item) => `<span class="p-tag p-component p-tag-secondary"><span class="p-tag-label">${
      item.trim().replace(/^(\S+)/, '<span class="font-normal">$1</span>')
    }</span></span>`)
    .join(' ');
}
